/**
 * Mapa central de Material Symbols Outlined usados no event-admin.
 *
 * Cada chave = "seção lógica" (dashboard, people, ranking…). Sidebar items E
 * page headers leem daqui — trocar o ícone aqui propaga pra todos os
 * consumidores automaticamente. Evita drift visual (sidebar com `group` e
 * header com `groups` etc.).
 *
 * Convenção: usar apenas nomes que existam no Material Symbols Outlined.
 */
export const EVENT_ADMIN_ICONS = {
  // top-level (sidebar groups)
  favorites: 'star',
  event: 'emoji_objects',
  submissions: 'description',
  reviews: 'balance',
  emails: 'mail',
  sessions: 'calendar_month',
  publication: 'menu_book',

  // event group
  dashboard: 'dashboard',
  checklist: 'checklist',
  settings: 'event_note',
  topics: 'local_offer',
  people: 'group',
  userProfile: 'person',

  // submissions group
  tracks: 'route',
  ranking: 'note_stack',
  authorsList: 'group',
  submissionsUpload: 'note_stack_add',
  submissionForm: 'assignment',
  notifyAuthors: 'send',
  showAllSubmissions: 'download',
  submissionStatistics: 'bar_chart',
  deletedSubmissions: 'delete',
  downloadSubmissionFiles: 'download',
  bibtexExport: 'code',
  certificateTemplate: 'workspace_premium',

  // reviews group
  reviewsConfiguration: 'tune',
  assignmentSuggestions: 'rule',
  reviewsUpload: 'playlist_add_check',
  reviewForm: 'rate_review',
  notifyReviewers: 'send',
  reviewsStatusBySubmission: 'assessment',
  reviewsStatusByUser: 'assessment',

  // emails group
  sendEmail: 'mail',
  emailStatus: 'mark_email_read',
  emailTemplate: 'article',

  // sessions group
  sessionsCalendar: 'calendar_view_month',
  sessionsProgram: 'list',

  // publication group
  publicationControls: 'tune',
  publicationStatus: 'bookmark_check',
  publicationProceedings: 'book_5',
} as const;

export type EventAdminIconKey = keyof typeof EVENT_ADMIN_ICONS;
